import type { RouteRecordRaw, Router } from 'vue-router'

const CommercialRoutes: RouteRecordRaw = {
  path: '/claim/commercial',
  name: 'CommercialModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'CommercialMainRoute',
      component: () => import('./views/CommercialView.vue'),
      meta: {
        title: 'commercial.commercialClaims',
      },
    },
    {
      path: 'create',
      name: 'CommercialCreateRoute',
      component: () => import('./views/CommercialUpsertView.vue'),
      meta: {
        title: 'commercial.createCommercial',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:commercialId',
      name: 'CommercialEditRoute',
      component: () => import('./views/CommercialUpsertView.vue'),
      meta: {
        title: 'commercial.editCommercial',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:commercialId',
      name: 'ViewCommercialRoute',
      component: () => import('./views/SingleCommercialView.vue'),
      meta: {
        title: 'commercial.ViewCommercial',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(CommercialRoutes)
}
